<template>
  <div class="p-4 min-h-screen flex flex-col justify-center">
    <div class="mb-8">
      <logos />
    </div>
    <intro />
  </div>
</template>

<script>
import Logos from '@/components/Logos'
import Intro from '@/components/Intro'

export default {
  components: {
    Logos,
    Intro
  }
}
</script>
